import "./Divider.scss";

export const Divider = ({ coverage, isVertical, wrapperClassName }) => (
    <div className={`divider-wrapper ${wrapperClassName || ''}`}>
        <div
            className="divider-line"
            style={{
                width: isVertical ? "1px" : coverage || "auto",
                height: isVertical ? coverage || "100%" : "1px",
                alignSelf: coverage ? "center" : "stretch",
            }}
        />
    </div>
);
